






import Vue from 'vue'

export default Vue.extend({
  props: {
    component: {
      type: String,
      default: 'div',
    },
  },
  mounted() {
    this.$emit('onReady', this.measure)
  },
  methods: {
    measure(): DOMRect {
      return (this.$refs.measureContainer as any)?.getBoundingClientRect()
    },
  },
})
